import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NumbersIcon(props: IconProps) {
    return <Icon {...props} iconKey={"numbers"}/>
}
